// extracted by mini-css-extract-plugin
export default {"root":"jsjMq0mb1u","root_forSingleInput":"pyYBmQboTu"};